import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PaginationControlsDirective, PaginationInstance } from 'ngx-pagination';
import { IPaginationControlsComponent } from 'shared.root/models/pagination.component.interface';

@Component({
  selector: '[nc-pagination-controls]',
  templateUrl: './pagination-controls.component.html',
  standalone: false,
})

export class PaginationControlsComponent implements IPaginationControlsComponent {
  @ViewChild('pagination', { static: true }) pagination: PaginationControlsDirective;

  static getDefaultConfig(): PaginationInstance {
    return {
      id: 'pagingControls',
      itemsPerPage: 5,
      currentPage: 1,
    } as PaginationInstance;
  }

  @Input() config: PaginationInstance;
  @Output() pageChange = new EventEmitter<number>();

  pageChanged(newPageNumber: number): void {
    this.config.currentPage = newPageNumber;
    this.pageChange.emit(newPageNumber);
  }

  first(): void {
    if (this.pagination.getCurrent() !== 1) {
      this.pagination.setCurrent(1);
    }
  }

  previous(): void {
    if (this.pagination.getCurrent() > 1) {
      this.pagination.previous();
    }
  }

  next(): void {
    if (this.pagination.getCurrent() < this.pagination.getLastPage()) {
      this.pagination.next();
    }
  }

  last(): void {
    if (this.pagination.getCurrent() !== this.pagination.getLastPage()) {
      this.pagination.setCurrent(this.pagination.getLastPage());
    }
  }

  getCompositeArrowId(arrowName: string): string {
    return (this.config && this.config.id) ? `${this.config.id}${arrowName}` : arrowName;
  }

  getCurrentPageId(): string {
    return (this.config && this.config.id) ? `${this.config.id}CurrentPage` : 'currentPage';
  }
}
